var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.selectedDevice &&
    _vm.selectedDevice.attributes &&
    _vm.selectedDevice.attributes.has_immobilization &&
    _vm.selectedDevice.attributes.has_immobilization !== 'false')?_c('el-tooltip',{attrs:{"content":_vm.selectedDevice.attributes.immobilized ? _vm.$t('vehicleTable.de_immobilize') : _vm.$t('vehicleTable.immobilize'),"placement":"bottom"}},[_c('img',{style:(_vm.selectedDevice.attributes.commandPending ? 'opacity: 0.2' : ''),attrs:{"alt":"immobilization","src":_vm.getIcon,"width":"38"},on:{"click":_vm.commandImmobilize}})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }